import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ChartModule } from 'primeng/chart';
import { DatePicker } from 'primeng/datepicker';
import { ProgressBar } from 'primeng/progressbar';

@Component({
  selector: 'app-insights',
  imports: [
    DatePicker,
    ButtonModule,
    CardModule,
    ChartModule,
    ProgressBar,
    CommonModule
  ],
  templateUrl: './insights.component.html',
  styleUrl: './insights.component.scss'
})
export class InsightsComponent {

  totalSpendBalanceData: any = {};
  lineOptions: any = {};

  barChartData: any = {};
  barChartOptions: any = {};

  locations: { name: string, percentage: number }[] = [
    {
      name: "Saudi Arabia",
      percentage: 40
    },
    {
      name: "Egypt",
      percentage: 40
    },
    {
      name: "UAE",
      percentage: 15
    }
  ];

  devices: { name: string, percentage: number , img: string }[] = [
    {
      name: "Mobile",
      percentage: 40,
      img: "../../../../assets/icons/mobile-icon.svg",
    },
    {
      name: "Tablet",
      percentage: 40,
      img: "../../../../assets/icons/tablet-icon.svg",

    },
    {
      name: "Desktop",
      percentage: 15,
      img: "../../../../assets/icons/desktop-icon.svg",

    }
  ]


  constructor(private cd: ChangeDetectorRef) { }

  ngOnInit() {
    this.initLineChart();
    this.initBarChart();
    this.getSpendAndBalance();
    // this.getClicksAndImpressions();
  }

  initLineChart() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    this.lineOptions = {
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      plugins: {
        pieTextPlugin: false,
        customPlugin: false,
        legend: {
          display: false,
          labels: {
            color: textColor,
            fontFamily: "'Nunito Sans', sans-serif"
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: "rgba(43, 48, 52, 0.40)",
            stepSize: 1,
            autoSkip: false,
            fontFamily: "'Nunito Sans', sans-serif"
          },
          grid: {
            display: false,
          },
        },
        y: {
          ticks: {
            color: "rgba(43, 48, 52, 0.40)",
            maxTicksLimit: 7,
            padding: 30,
            fontFamily: "'Nunito Sans', sans-serif"
          },
          grid: {
            tickMarkLength: 20,
            color: "#EAEAEA",

          },
        }
      }
    };
    this.totalSpendBalanceData = {
      labels: [],
      datasets: [
        {
          data: [],
          fill: true,
          borderColor: [
            "green",
            "green",
            "green",
            "green",
          ],
          tension: 0.1,
          pointBackgroundColor: '#14AB5F',
          borderWidth: 1,
          backgroundColor: [
            "green",
            "green",
            "green",
            "green",
          ]

        },

      ]
    };
  }

  getSpendAndBalance() {
    this.totalSpendBalanceData = {
      labels: ["1 JAN", "2 JAN", "3 JAN", "4 JAN", "5 JAN"],
      datasets: [
        {
          data: [1000, 2000, 3000, 40000, 50000],
          fill: true,
          tension: 0.5,
          borderColor: "#5BC4FF",
          borderWidth: 1,
          pointBackgroundColor: "#5BC4FF",
          pointBorderColor: "#5BC4FF",
          backgroundColor: (context: any) => {
            const bgColor = [
              '#5bc4ff08',
              '#5bc4ff08',
              '#5bc4ff08',
              '#5bc4ff08',
            ];
            if (!context.chart.chartArea) {
              return;
            }
            const { ctx, data, chartArea: { top, bottom } } = context.chart;
            const gredientBg = ctx.createLinearGradient(0, top, 0, bottom);
            gredientBg.addColorStop(0, bgColor[0]);
            gredientBg.addColorStop(0.5, bgColor[0]);
            gredientBg.addColorStop(1, bgColor[1]);
            return gredientBg;
          }
        },
      ]
    };
  }


  initBarChart() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    this.barChartOptions = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        legend: {
          labels: {
            color: textColor
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: "#6D758F",
            font: {
              weight: 500
            }
          },
          grid: {
            color: "transparent",
            drawBorder: false
          }
        },
        y: {
          ticks: {
            color: "#030229"
          },
          grid: {
            color: "#E1E4ED",
            drawBorder: false
          }
        }
      },
      datasets: {
        bar: {
          categoryPercentage: 0.8,
          barPercentage: 0.85
        }
      }
    };
    this.barChartData = {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'My First dataset',
          backgroundColor: "#2388FF",
          borderColor: "#2388FF",
          data: [65, 59, 80, 81, 56, 55, 40],
          borderRadius: 8,
          borderSkipped: false,
          barThickness: 30,
        },
        {
          label: 'My Second dataset',
          backgroundColor: "#8DC1FF",
          borderColor: "#8DC1FF",
          data: [28, 48, 40, 19, 86, 27, 90],
          borderRadius: 8,
          borderSkipped: false,

        }
      ]
    };
    this.cd.markForCheck()

  }

  getClicksAndImpressions() {
  }
}
